export const menuFixed = () => {
    $('#main').css('margin-top', $('header').height())

    const headerFixed = () => {
        if($('header').offset().top > 1) {
            $('header').addClass('header-sticky')
        } else {
            $('header').removeClass('header-sticky')
        }
    }

    headerFixed()
    $(window).scroll(() => {
        headerFixed()
    })
}

export const menuMobile = () => {
    $('.navbar-toggler').click(function() {
        $(this).toggleClass('open')
        $('#navbar').toggleClass('open')
    })
}

export const headerSearch = () => {
    $('.btn-search').click(function() {
        $(this).toggleClass('open')
        $('.nav-search .search-form').toggleClass('open')
    })
}